


function moduleQuoteSlider(){
	if($('.m__quote-slider .quote-slider-slick li').length > 1){
		$('.quote-slider-slick').slick({
			dots: true,
			arrows:false,
			infinite: true,
			autoplay:true,
			speed: 300,
			centerMode: true,
			variableWidth: true,
			responsive: [
		    {
		      breakpoint: 890,
		      settings: {
		        variableWidth: false,
		      }
		    }
		  ]
		});
	}
}